import axios from "axios";
import API_URL from "../../../redux2";

export const getAirArabiaPricing = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/price", data);
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getAirArabiaPricingBundle = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/price-with-bundle", data);
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getAirArabiaBooking = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/book", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const issueAirArabiaTicket = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/issue-ticket", data);
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getAirArabiaTicket = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/get-booking", {
      bookingReference: data,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getBaggageDetails = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/baggage-details", data);
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getMealDetails = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/meal-details", data);
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getSeatDetails = async (data, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.post(API_URL + "airarabia/seat-selection", data);
    return res.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};
